import { ScrollArea } from "@cmp-src/primitives/scroll-area";
import React from "react";
import { IResource, Office } from "@gettactic/api";
import { ListHourRules } from "@/features/settings/components/hours/rule/ListHoursRules";

export interface HoursPanelProps {
  office: Office;
  resources?: IResource[] | null;
}

export const HoursPanel = ({ office, resources }: HoursPanelProps) => {
  return resources ? (
    <ScrollArea className="h-full">
      <ListHourRules
        title="Custom Hours"
        office={office}
        resources={resources}
      />
    </ScrollArea>
  ) : null;
};
